import { useEffect,useState } from 'react';
import {Typography, ListItem, Drawer,List ,ListItemIcon,ListItemText, IconButton,Button} from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AddLocationIcon from '@mui/icons-material/AddLocation';
import {db,collection,getDocs,doc,onSnapshot} from '../firebase/init'
import RedoIcon from '@mui/icons-material/Redo';
import Tooltip from "@mui/material/Tooltip";
import Slide from 'react-reveal/Slide';
import Magnifier from "react-magnifier";
import { fetchSuggestions } from '../supabaseApi'

const SuggestionsItemPanel=({itemToSuggest,mapRef,itemToPosition,handleItemToPosition,handleItemToSuggest,suggestions,handleSuggestions,setItemsToMark})=>{
console.log(suggestions)

  useEffect(async() => {
    if (!itemToSuggest?.properties?.id) return
    try {
      let res = await fetchSuggestions(itemToSuggest.id)
      handleSuggestions(res)
    } catch (err) {
      console.log(err)
    }
  }, [itemToSuggest])
  
  return <div style={{width:'25vw',textAlign:'center',minWidth:'400px',overflowX:'hidden'}}> 
  <div style={{display:'flex',justifyContent:'space-between', padding:'10px 0 0 0'}}>
  
  <Tooltip title={itemToPosition ? "Cancel" 
          :
          "Add location"}>
  <Button variant={itemToPosition ? 'contained' : "text"}
      
        onClick={()=>{
          if (itemToPosition){
            handleItemToPosition(null)
            handleSuggestions([])
            setItemsToMark([])

          }
          else
          {
            handleItemToPosition(itemToSuggest, true)
          }
          }
        }
        >
        <AddLocationIcon/>
     
          </Button>
          </Tooltip>
          <Tooltip title="Back">
  <Button   variant="text"
  onClick={()=>{
    handleItemToSuggest(null)
    handleSuggestions([])
  }}
  >
  <RedoIcon />
  </Button>
  </Tooltip>
  </div>
  

  <List sx={{padding:'0 10px'}}>
  {suggestions &&
     suggestions.map(suggestion=> 
      <Slide right>
     <ListItem 
  sx={{ borderBottom: 1}} >
   <ListItemIcon
        sx={{cursor:'pointer'}}
        
        onClick={()=>{
          mapRef.easeTo({zoom:17,
           center: [suggestion.geometry.coordinates[1], suggestion.geometry.coordinates[0]],
         });
        }}
        >
          <IconButton
         >          <LocationOnIcon/>

                    </IconButton>
  </ListItemIcon>
         <ListItemText sx={{wordBreak:'break-all',paddingRight:'10px'}} primary={suggestion.properties.title && <p style={{fontStyle:"italic"}}>"{suggestion.properties.title}"</p>} 
         secondary={suggestion.properties.title && <p style={{fontSize:"10px"}}>-{suggestion.properties.author.username}</p>}
         />
      <img 
      src={`https://api.mapbox.com/styles/v1/${process.env.REACT_APP_MAPBOX_ACCOUNT}/${process.env.REACT_APP_MAPBOX_STYLE_ID}/static/${suggestion.geometry.coordinates[1]},
      ${suggestion.geometry.coordinates[0]},15,0,0/150x150?access_token=${process.env.REACT_APP_MAPBOX_TOKEN}`}
      />
    </ListItem> 
    </Slide>
    ) }
  </List>
  </div>
        
}

export default SuggestionsItemPanel